<template>
  <div class="connect-settings" :class="isDarkMode ? 'dark' : ''">
    <b-overlay :show="isLoading" rounded="sm">
      <b-card title="Convey Connect Settings">
        <div class="row d-flex p-4 mt-4">
          <div class="col-xl-6 col-md-12">
            <b-form-group>
              <label><span class="fw-bold">SDK: </span>Api Audience</label>
              <b-form-input
                name="sdk:apiAudience"
                v-model="settings['sdk:apiAudience']"
                @change="touchSetting($event, 'sdk:apiAudience')"
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <label><span class="fw-bold">SDK: </span>SSO Client ID</label>
              <b-form-input
                name="sdk:ssoClientId"
                v-model="settings['sdk:ssoClientId']"
                @change="touchSetting($event, 'sdk:ssoClientId')"
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <label><span class="fw-bold">SDK: </span> SSO Host</label>
              <b-form-input
                name="sdk:ssoHost"
                v-model="settings['sdk:ssoHost']"
                @change="touchSetting($event, 'sdk:ssoHost')"
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <label><span class="fw-bold">SDK: </span> Config</label>
              <b-form-textarea
                name="sdk:config"
                v-model="settings['sdk:config']"
                @change="touchSetting($event, 'sdk:config')"
                rows="4"
              ></b-form-textarea>
            </b-form-group>
          </div>
          <div class="col-xl-6 col-md-12">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="conveyConnectEnabled"
                name="conveyConnectEnabled"
                :checked="settings.conveyConnectEnabled"
                @change="
                  touchSetting(
                    $event.target.checked.toString(),
                    'conveyConnectEnabled'
                  )
                "
              />
              <label class="form-check-label" for="conveyConnectEnabled"
                >Convey Connect Enabled</label
              >
            </div>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                name="sdk:enabled"
                :checked="settings['sdk:enabled']"
                @change="
                  touchSetting($event.target.checked.toString(), 'sdk:enabled')
                "
              />
              <label class="form-check-label">
                <span class="fw-bold">SDK </span>Enabled</label
              >
            </div>
          </div>
        </div>

        <b-button
          pill
          variant="info"
          :disabled="!settingsUpdated"
          class="save-settings"
          @click="save"
          >Save Settings</b-button
        >
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "ConnectSettings",
  computed: {
    ...mapGetters("user", ["currentToken", "isDarkMode"]),
    ...mapGetters("agency", ["currentAgencyId"]),
    ...mapState({
      settings: (state) => state.agency.settings,
      agency: (state) => state.agency.agency,
    }),
  },
  data() {
    return {
      localSettings: {},
      settingsUpdated: false,
      agencyUpdated: false,
      isLoading: false,
      vueEnvironment: process.env.NODE_ENV,
    };
  },
  created() {},
  methods: {
    ...mapActions("agency", ["updateAgencySettings"]),
    async save() {
      let statusCode = null;
      if (this.settingsUpdated) {
        let payload = [];
        for (const [key, value] of Object.entries(this.localSettings))
          payload.push({ name: key, value: value, component: "agency" });

        try {
          this.isLoading = true;
          await this.$ConveyApi.settingsApi.updateAgencySettings({
            agencyId: this.agencyId,
            payload
          })
            .then((res) => {
              this.updateAgencySettings(res.data.data);
              statusCode = res.status;
            })
            .catch(() => {
              this.$toastr("error", "An error occurred. Please try again.");
            });
        } catch (err) {
          this.$toastr("error", "An error occurred. Please try again.");
        } finally {
          this.isLoading = false;
        }
      }

      if (statusCode === 200) {
        this.$toastr("success", "Settings Updated.");
      } else {
        this.$toastr("error", "An error occurred. Please try again.");
      }
    },
    touchSetting(value, field) {
      this.settingsUpdated = true;

      this.localSettings[field] = value;
    },
  },
};
</script>

<style lang="scss">
.connect-settings {
  & .card {
    border-radius: 1rem;
  }
  & .card-title {
    font-weight: 600;
  }

  & .col-form-label,
  label {
    color: #232323;
    font-weight: 500;
  }
  & .form-group {
    margin-bottom: 2rem;
  }
  & .form-control:disabled {
    cursor: not-allowed;
  }

  &.dark {
    & .col-form-label,
    label {
      color: #b2b9bf !important;
      font-weight: 500;
    }
    input::placeholder {
      color: #b2b9bf !important;
      opacity: 0.5;
    }
  }

  & .form-switch {
    margin-bottom: 2rem;
  }
  & .form-switch .form-check-input {
    width: 2.7em;
    height: 1.5rem;
  }
  & .form-check-label {
    margin-left: 1rem;
  }

  & .save-settings {
    border-radius: 6px;
    float: right;
    margin: 1.2rem;
  }
}
</style>
